export default "__VITE_ASSET__BAfe$ADW__"